import {
    VIDEO_DETAILS
} from './Types';
import axios from "axios/index";
import {API_URL} from "../config/config";
import {getAuthToken, getAuthUserDetails} from "./Common";


/**
 * getVideoDetail
 * @param data
 * @param callback
 * @returns {function(*)}
 */
export function getVideoDetail(callback) {
    const authToken = getAuthToken();   
    return (dispatch) => {
        axios.get(`${API_URL}deck/videos`)
            .then((response) => { 
                callback(response);
                dispatch({
                    type: VIDEO_DETAILS,
                    payload: response.data
                });
            })
            .catch(function (error) {
                callback(error.response);
            });             
            //     dispatch({
            //         type: VIDEO_DETAILS,
            //         payload: response.data
            //     })
            // });
    }   
    // return (dispatch)=> {
    //     dispatch({
    //         type    : VIDEO_DETAILS,
    //         payload : [{
    //                     "videoId":2434324,
    //                     "title":"Some title",
    //                     "description":"Some description",
    //                     "source": "/assets/videos/small.mp4",
    //                     "poster": "UTF-8 encoded byte array for the pic",
    //                     }]                         
    //     });
    
    // }
}


// WEBPACK FOOTER //
// ./actions/VideoAction.js